import React, { JSX } from "react";
import { Navigate } from "react-router-dom";
import { ProtectedRoute as AuthProtectedRoute } from "../auth/AuthContext";
import { useCanAccess } from "./useCanAccess";

export function ProtectedRoute({ children }: { children: JSX.Element }) {
  // Reuse existing auth guard to ensure login
  return <AuthProtectedRoute>{children}</AuthProtectedRoute>;
}

export function RequirePermission({ permission, children }: { permission: string; children: JSX.Element }) {
  const { canAccess, isLoading } = useCanAccess();
  if (isLoading) return null; // could be a skeleton
  if (!canAccess(permission)) return <Navigate to="/403" replace />;
  return children;
}
